import React, { createContext, useContext, useEffect, useState } from 'react';

import Cookies from 'js-cookie';
import {getCompanyPermissions, getUserPermissions} from "./permissionService";
// Permission checks accept any backend enum string. Use UserPermission / CompanyPermission from permissionCodes.js (re-exported in utils.js) for dot access without maintaining lists.
import {userUUIDExists} from "../utils/requestUtils";

const PermissionContext = createContext();

export const PermissionProvider = ({ children, refreshInterval = 5 * 60 * 1000 }) => {
    const [companyPermissions, setCompanyPermissions] = useState([]);
    const [userPermissions, setUserPermissions] = useState([]);
    const [loadingPermissions, setLoadingPermissions] = useState(true);
    const [userUUID, setUserUUID] = useState(() => Cookies.get('userUUID'));

    const fetchPermissions = async () => {
        if (!userUUID) {
            setUserPermissions([]);
            setCompanyPermissions([]);
            setLoadingPermissions(false);
            return;
        }

        try {
            userUUIDExists().then(async e => {
                const userPerms = await getUserPermissions();
                setUserPermissions(userPerms);
                const companyPerms = await getCompanyPermissions();
                setCompanyPermissions(companyPerms);
                
            }).catch(() => {
                setUserPermissions([]);
                setCompanyPermissions([]);
                setLoadingPermissions(false);
            });

        } catch (error) {
            console.error('Erro ao buscar permissões:', error);
            setUserPermissions([]);
            setCompanyPermissions([]);
        } finally {
            setLoadingPermissions(false);
        }
    };

    useEffect(() => {
        setUserUUID(Cookies.get('userUUID'));

        if (userUUID) {
            fetchPermissions(); // Busca inicial

            const interval = setInterval(() => {
                fetchPermissions();
            }, refreshInterval);

            return () => clearInterval(interval);
        } else {
            setLoadingPermissions(false);
        }
    }, [userUUID, refreshInterval]);

    const hasUserPermission = (permission) => {
        return userPermissions.includes(permission);
    };
    
    const hasCompanyPermission = (permission) => {
        return companyPermissions.includes(permission);
    };

    return (
        <PermissionContext.Provider value={{ userPermissions, companyPermissions, hasUserPermission, hasCompanyPermission, loadingPermissions }}>
            {children}
        </PermissionContext.Provider>
    );
};

export const usePermission = () => useContext(PermissionContext);
